import(/* webpackMode: "eager" */ "/codebuild/output/src3594774605/src/github.com/bitstone/offerz-nextjs/src/app/[lang]/(main)/not-found.tsx");
